import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import { Action, Getter } from 'vuex-class';
// @ts-ignore
import BcSnackbar, { CBcSnackbar } from '@/components/BcSnackbar.vue';
// @ts-ignore
import BcDialog, { CBcDialog, CBcDialogForm } from '@/components/Dialog.vue';
class DataObject {
    constructor(op) {
        const that = this;
        if (op && /object/i.test(typeof op)) {
            Object.keys(op).forEach((k) => {
                that[k] = op[k];
            });
        }
    }
}
let DeviceRegister = class DeviceRegister extends Vue {
    constructor() {
        super();
        this.searchOptions = {
            deviceType: '',
            quickly: '',
            bindingType: 0,
            manager: '',
            hospatalName: '',
            onState: '',
        };
        this.formLoading = false;
        this.formLicenseDaysRule = [];
        this.dlgSerialMgr = new CBcDialog(new CBcDialogForm());
        this.dlgSerial = new CBcDialog(new CBcDialogForm());
        this.list = [];
        this.snackbar = new CBcSnackbar();
        this.dialog = {
            editor: -1,
            title: '',
            text: '',
            visible: false,
            persistent: false,
            form: false
        };
        this.dialogLicense = {
            editor: -1,
            title: '',
            text: '',
            visible: false
        };
        this.formSubmiting = false;
        this.formValid = true;
        this.formLicense = {
            serialcode: '',
            days: '',
            deviceID: '',
            deviceType: '',
            creator: '',
            remark: '',
        };
        this.dlgResult = {
            visible: false
        };
        this.dlgPurchase = {
            visible: false,
            registerInput: false,
            registerLicense: '',
        };
        this.licenseValid = /true/i.test('<%- licenseValid %>');
        this.license = {
            code: ''
        };
        this.licenseImgUrl = '';
        this.pageLoading = false;
        this.isDevLiceUpdate = false;
        const that = this;
        this.formData = new DataObject({
            type: '',
            name: '',
            mode: '',
            deviceId: '',
            deviceNo: '',
            serialNumber: '',
        });
        this.currentItem = {
            type: '',
            name: '',
            deviceId: '',
            serialNumber: '',
        };
    }
    get routeQuery() {
        const that = this;
        return that.$router.currentRoute.query || {};
    }
    get devLiceUpdateValue() {
        const that = this;
        return that.routeQuery.devLiceUpTxt;
    }
    get devLiceUpdateCryptType() {
        const that = this;
        return that.routeQuery.et;
    }
    get devNodeVersion() {
        const that = this;
        return that.routeQuery.v || '';
    }
    mounted() {
        const that = this;
        const deviceSerial = that.routeQuery.serial;
        const deviceNo = that.routeQuery.no;
        that.getSerialList().then((ser) => {
            if (that.listSerial.length && that.isDevLiceUpdate && deviceSerial) {
                that.listSerial.forEach((its) => {
                    if (its.serial.toLocaleLowerCase() === deviceSerial.toLowerCase()) {
                        that.searchOptions.deviceMode = its.serial;
                    }
                });
            }
        });
        that.getList();
        that.isDevLiceUpdate = (!!that.devLiceUpdateValue);
        if (that.isDevLiceUpdate) {
            if (deviceNo) {
                that.searchOptions.quickly = deviceNo;
            }
            that.$clipboard(that.devLiceUpdateValue);
            that.snackbar.info('请选择需要授权的设备');
        }
        that.formLicenseDaysRule = [(v) => !!v || '请输入天数', (v) => (/^\d+$/i.test(v)) || '请输入具体天数', !that.isSrvTestEnv ? undefined : (v) => (v < 181) || '测试环境天数最大180天'].filter((v) => !!v);
    }
    getSerialList() {
        const that = this;
        that.dlgSerialMgr.loading = true;
        return that.fetchDeviceSerialList().then(() => {
            that.dlgSerialMgr.loading = false;
        }).catch((e) => {
            that.dlgSerialMgr.loading = false;
            console.log('error of get device serial: ', e);
            that.snackbar.error('获取设备机型列表出错');
        });
    }
    deviceSerialMgrDisplay() {
        const that = this;
        that.dlgSerialMgr.displayText = false;
        that.dlgSerialMgr.negative.text = '关闭';
        that.dlgSerialMgr.positive.isText = false;
        that.dlgSerialMgr.positive.visible = false;
        that.dlgSerialMgr.title = '设备机型';
        that.dlgSerialMgr.persistent = true;
        that.dlgSerialMgr.autoClose = false;
        that.dlgSerialMgr.rejectedAction = () => {
            that.dlgSerialMgr.visible = false;
        };
        that.dlgSerialMgr.rejectedAction = () => {
            that.dlgSerialMgr.visible = false;
        };
        that.dlgSerialMgr.width = '50%';
        that.dlgSerialMgr.visible = true;
    }
    deviceSerialDisplay(type, item) {
        const that = this;
        const typeText = /edit/i.test(type) ? '修改' : /add/i.test(type) ? '新增' : '删除';
        that.dlgSerial.displayText = /delete/i.test(type);
        that.dlgSerial.text = '是否删除该机型';
        that.dlgSerial.positive.isText = false;
        that.dlgSerial.positive.text = /edit/i.test(type) ? '保存' : /add/i.test(type) ? '新增' : '删除';
        that.dlgSerial.title = `${typeText}设备机型`;
        that.dlgSerial.persistent = /edit/i.test(type);
        that.dlgSerial.autoClose = false;
        that.dlgSerial.form = Object.assign(item || {});
        if (that.$refs && that.$refs.refSerial)
            that.$refs.refSerial.resetValidation();
        that.dlgSerial.closeAction = () => {
            that.dlgSerial.persistent = false;
        };
        that.dlgSerial.rejectedAction = () => {
            that.dlgSerial.visible = false;
        };
        that.dlgSerial.acceptedAction = () => {
            that.dlgSerial.loading = true;
            const method = /add/i.test(type) ? 'post' : /edit/i.test(type) ? 'put' : 'delete';
            if (/add/i.test(type)) {
                if (that.$refs && that.$refs.refSerial && !that.$refs.refSerial.validate() || !that.dlgSerial.form.serial) {
                    that.dlgSerial.loading = false;
                    return that.snackbar.warn('必要内容未输入');
                }
                that.axios[method]('/api/device/serial', that.dlgSerial.form).then((res) => {
                    that.dlgSerial.loading = false;
                    that.snackbar.success('获取设备机型新增成功');
                    that.dlgSerial.loading = false;
                    that.dlgSerial.visible = false;
                    that.getSerialList();
                }).catch((e) => {
                    that.dlgSerial.loading = false;
                    console.log('error of get device serial: ', e);
                    that.snackbar.error('获取设备机型列表出错');
                });
            }
            else if (/edit|delete/i.test(type)) {
                console.log('m:', method, typeText, that.dlgSerial.form);
                that.axios[method](`/api/device/serial/${that.dlgSerial.form.id}`, /edit/i.test(type) ? that.dlgSerial.form : undefined).then((res) => {
                    that.dlgSerial.loading = false;
                    that.snackbar.success(`设备机型${typeText}成功`);
                    that.dlgSerial.visible = false;
                    that.getSerialList();
                }).catch((e) => {
                    that.dlgSerial.loading = false;
                    console.log(`error of ${type} device serial: `, e);
                    that.snackbar.error(`设备机型${typeText}出错`);
                });
            }
        };
        that.dlgSerial.width = '45%';
        that.dlgSerial.visible = true;
    }
    async linkToHosptail(hospatalName, id) {
        const that = this;
        if (id)
            that.$router.push({ name: 'HospitalInfo', params: { id: id } });
    }
    async getList() {
        const that = this;
        that.pageLoading = true;
        try {
            //const res: any = await that.axios.get('/api/device')
            that.pageLoading = false;
            //that.list = res && res.data && res.data.result || []
            await that.fetchDevices(); // todo:store中对象，后期应转移为该对象
            that.list = that.deviceList;
        }
        catch (e) {
            that.pageLoading = false;
            console.log('error of get list:', e);
            that.snackbar.error(e.info || e.errorInfo || e.result || e.error || e.toString() || '设备信息获取失败.');
        }
    }
    async updateItem(itemId) {
        const that = this;
        if (!itemId)
            return that.snackbar.warn('请指定要更新的设备');
        try {
            const res = await that.axios.get('/api/device', { params: { id: itemId } });
            that.list = that.list.map((v) => {
                // eslint-disable-next-line prefer-destructuring
                if (v.deviceId === itemId)
                    v = (res && res.data && res.data.result || [])[0];
                return v;
            });
        }
        catch (e) {
            console.log('error of get list item:', e);
            that.snackbar.error(e.info || e.errorInfo || e.result || e.error || e.toString() || '设备信息获取失败.');
        }
    }
    get filterDeviceList() {
        const that = this;
        const l = that.list.filter((v) => !that.searchOptions.quickly ? v : new RegExp(that.searchOptions.quickly, 'i').test(v.name) || new RegExp(that.searchOptions.quickly, 'i').test(v.hospitalSpell) || new RegExp(that.searchOptions.quickly, 'i').test(v.deviceNo))
            .filter((vDT) => new RegExp(that.searchOptions.deviceType || '', 'i').test(vDT.type))
            .filter((vDM) => new RegExp(that.searchOptions.deviceMode || '', 'i').test(vDM.mode))
            .filter((vHS) => new RegExp(that.searchOptions.hospatalName || '', 'i').test(vHS.hospitalName))
            .filter((vMA) => new RegExp(that.searchOptions.manager || '', 'i').test(vMA.manager))
            .filter((vHN) => !that.searchOptions.bindingType ? vHN : that.searchOptions.bindingType === 1 ? String(vHN.hospitalName) : !String(vHN.hospitalName))
            .filter((vDT) => this.searchOptions.onState ? vDT.onState === that.searchOptions.onState : vDT);
        return l;
    }
    deleteItem(item) {
        const that = this;
        if (that.$refs.refFormDevice)
            that.$refs.refFormDevice.resetValidation();
        that.dialog.persistent = false;
        that.dialog.editor = 3;
        that.dialog.title = '删除设备';
        that.dialog.text = `确定删除${item && item['name'] || ''}该设备，操作不可恢复，请确认.`;
        that.formData = new DataObject(item);
        that.dialog.visible = true;
    }
    editItem(item) {
        const that = this;
        if (that.$refs.refFormDevice)
            that.$refs.refFormDevice.resetValidation();
        that.dialog.persistent = true;
        that.dialog.editor = 2;
        that.dialog.title = '编辑设备';
        that.dialog.text = '';
        that.formData = new DataObject(item);
        that.dialog.visible = true;
    }
    createNew() {
        const that = this;
        if (that.$refs.refFormDevice)
            that.$refs.refFormDevice.resetValidation();
        that.dialog.persistent = true;
        that.dialog.editor = 1;
        that.dialog.title = '新增设备';
        that.dialog.text = '';
        that.formData = new DataObject({ creator: that.userInfo.name });
        that.dialog.visible = true;
    }
    deviceLicense(item) {
        const that = this;
        that.formLicense = {
            serialcode: that.isDevLiceUpdate ? that.devLiceUpdateValue : item.serialNumber,
            cryptType: that.isDevLiceUpdate ? that.devLiceUpdateCryptType : '',
            days: item.license && item.license.days || '',
            deviceId: item.id,
            deviceNo: item.deviceNo,
            deviceType: item.type,
            deviceSerial: item.mode,
            creator: that.userInfo.userName,
            remark: '',
            nodeVersion: that.devNodeVersion || ''
        };
        that.dialogLicense.visible = true;
    }
    async createNewHandle() {
        const that = this;
        const body = that.formData;
        if (that.$refs && that.$refs.refFormDevice && !that.$refs.refFormDevice.validate()) {
            // eslint-disable-next-line no-throw-literal
            throw '所填写内容条件未满足，请检查';
        }
        body['deviceId'] = body && body.deviceNo;
        body['type'] = body && body.type.text || body.type;
        return that.axios.post('/api/device', body);
    }
    async editItemHandle() {
        const that = this;
        const body = that.formData;
        if (that.$refs && that.$refs.refFormDevice && !that.$refs.refFormDevice.validate()) {
            // eslint-disable-next-line no-throw-literal
            throw '所填写内容条件未满足，请检查';
        }
        body['type'] = body && body.type.text || body.type;
        return that.axios.put('/api/device/' + that.formData.id, that.formData);
    }
    async deleteItemHandle() {
        const that = this;
        return that.axios.delete('/api/device/' + that.formData.id);
    }
    close() {
        const that = this;
        that.dialog.visible = false;
    }
    async save() {
        const that = this;
        const typeName = (that.dialog.editor === 1 ? '新增' : that.dialog.editor === 2 ? '修改' : '删除') + '设备信息';
        console.log('save item:');
        try {
            that.formLoading = true;
            switch (that.dialog.editor) {
                case 1:
                    await that.createNewHandle();
                    break;
                case 2:
                    await that.editItemHandle();
                    break;
                case 3:
                    await that.deleteItemHandle();
                    break;
                default:
                    break;
            }
            that.formLoading = false;
            that.getList();
            that.dialog.visible = false;
            that.snackbar.success(`${typeName}成功`);
        }
        catch (e) {
            console.log('信息修改失败:', e);
            that.formLoading = false;
            that.snackbar.error(e.error || e.info || e.errorInfo || e.result || e.toString() || `${typeName}失败`);
        }
    }
    async licenseHandle() {
        const that = this;
        try {
            const body = that.formLicense;
            body['deviceType'] = body && body.deviceType && body.deviceType.text || body.deviceType;
            that.formSubmiting = true;
            const res = await that.axios.post('/api/device/licenses/register', body);
            that.dialogLicense.visible = false;
            that.dlgResult.visible = true;
            that.formSubmiting = false;
            that.license.code = res.data.license;
            const key = res.data.keySuffix;
            const qrcodeRaw = await that.axios.post('/api/device/licenses/qrcode', { text: `http://localhost:3004/license/expire?c=${encodeURIComponent(res.data.license)}&k=${key}` }, { responseType: 'blob' });
            const reader = new FileReader();
            reader.readAsDataURL(qrcodeRaw.data);
            reader.onload = () => {
                that.licenseImgUrl = reader.result;
            };
            that.snackbar.success('授权码生成成功');
            that.updateItem(parseInt(body.deviceId, 10));
            that.$router.push({ query: {} });
            that.isDevLiceUpdate = false;
        }
        catch (error) {
            that.formSubmiting = false;
            const errRes = error && error.response && error.response.data;
            console.log('error of license register:', error, (errRes && errRes.error) || (errRes && errRes.result));
            that.snackbar.error(error && (error.errorInfo || error.result || error.toString()) || ('注册失败：' + (errRes && (errRes.error || errRes.result) || error)));
        }
    }
};
__decorate([
    Getter('deviceSerialList')
], DeviceRegister.prototype, "listSerial", void 0);
__decorate([
    Getter
], DeviceRegister.prototype, "userInfo", void 0);
__decorate([
    Getter
], DeviceRegister.prototype, "deviceTypeList", void 0);
__decorate([
    Getter
], DeviceRegister.prototype, "isSrvTestEnv", void 0);
__decorate([
    Action
], DeviceRegister.prototype, "fetchDevices", void 0);
__decorate([
    Action
], DeviceRegister.prototype, "fetchDeviceSerialList", void 0);
__decorate([
    Getter
], DeviceRegister.prototype, "deviceList", void 0);
__decorate([
    Getter
], DeviceRegister.prototype, "deviceOnStateList", void 0);
DeviceRegister = __decorate([
    Component({
        name: 'DeviceInfo',
        data: () => ({
            formRules: {
                // @ts-ignore
                days: [v => !!v || '请输入天数', v => (/^\d+$/i.test(v)) || '请输入具体天数'],
                // @ts-ignore
                notEmpty: [v => !!v || '该字段为必填项'],
            }
        }),
        components: {
            BcDialog,
            BcSnackbar,
        }
    })
], DeviceRegister);
export default DeviceRegister;
;
